import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import A1 from '../Login/Chatbot.jpeg';


const ChangePassword = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: '',
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
    });

    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData({
            ...formData,
            [id]: value,
        });
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.email.trim()) newErrors.email = 'Email is required';
        if (!formData.oldPassword.trim()) newErrors.oldPassword = 'Old password is required';
        if (!formData.newPassword.trim()) newErrors.newPassword = 'New password is required';
        if (formData.newPassword !== formData.confirmPassword)
            newErrors.confirmPassword = 'Passwords do not match';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        
        e.preventDefault();
        if (validate()) {
            setIsLoading(true);
            try {
                const response = await axios.post('https://rvapi.emedha.in/auth/api/updatePassword', formData);
                if (response.data.success) {
                    alert('Password updated successfully');
                    navigate('/');
                } else {
                    alert(response.data.message);
                }
            } catch (error) {
                console.error('Error updating password:', error);
                alert('There was an error updating the password. Please try again.');
            }
            setIsLoading(false);
        }
    };


    return (
        <div className="container-fluid d-flex justify-content-center align-items-center bg-light">
            <div className="card shadow-sm p-4" style={{ maxWidth: '400px', width: '100%' }}>
                <div className="text-center">
                    <img src={A1} alt="ChatBot Services" style={{ width: '100px' }} />
                    <h2 className="fw-bold text-primary">
                        Emedha ChatBot <span className="text-success">Services</span>
                    </h2>
                    <p className="text-muted">Welcome back! 👋</p>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="email" className="form-label">Email</label>
                        <input type="email" className="form-control" id="email" value={formData.email} onChange={handleChange} placeholder="Enter your email" />
                        {errors.email && <small className="text-danger">{errors.email}</small>}
                    </div>

                    <div className="mb-3">
                        <label htmlFor="oldPassword" className="form-label">Old Password</label>
                        <input type="password" className="form-control" id="oldPassword" value={formData.oldPassword} onChange={handleChange} placeholder="Enter your old password" />
                        {errors.oldPassword && <small className="text-danger">{errors.oldPassword}</small>}
                    </div>

                    <div className="mb-3">
                        <label htmlFor="newPassword" className="form-label">New Password</label>
                        <input type="password" className="form-control" id="newPassword" value={formData.newPassword} onChange={handleChange} placeholder="Enter your new password" />
                        {errors.newPassword && <small className="text-danger">{errors.newPassword}</small>}
                    </div>

                    <div className="mb-3">
                        <label htmlFor="confirmPassword" className="form-label">Confirm New Password</label>
                        <input
                            type="password"
                            className="form-control"
                            id="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            placeholder="Confirm your new password"
                        />
                        {errors.confirmPassword && <small className="text-danger">{errors.confirmPassword}</small>}
                    </div>

                    <button type="submit" className="btn btn-sm btn-primary" disabled={isLoading}>
                        {isLoading ? 'Updating...' : 'Update Password'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ChangePassword;
